import { NgModule } from '@angular/core';
import { CommonModule, DatePipe, CurrencyPipe, DecimalPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { RouterModule,Routes } from '@angular/router';
import { AdminMainComponent } from './admin-main/admin-main.component';
import { SidebarComponent } from '../reusable_components/sidebar/sidebar.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DistributionComponent } from './distribution/distribution.component';
import { STJSFleetComponent } from './stjs-fleet/stjs-fleet.component';
import { HighchartsChartModule } from 'highcharts-angular';
import { SharedSnlComplibModule } from '../shared-module/shared-snl-complib.module';
import { SearchInputComponent } from '../component-library/search-input/search-input.component';
import { ShipOwnersPipe } from '../../pipes/ship-owners.pipe';
import { NegativeToBracketPipe } from '../../pipes/negativeToBracket.pipe';
import { MsalGuard } from '@azure/msal-angular';
import { NgSelectModule } from '@ng-select/ng-select';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AddShipComponent } from './stjs-fleet/stjs_components/add-ship/add-ship.component';
import { ShipDetailComponent } from './stjs-fleet/stjs_components/ship-detail/ship-detail.component';
import { MarkAsStatusComponent } from './stjs-fleet/stjs_components/mark-as-status/mark-as-status.component';
import { AddEditPenaltyComponent } from './stjs-fleet/stjs_components/add-edit-penalty/add-edit-penalty.component';
import { EditShipDetailsComponent } from './stjs-fleet/stjs_components/edit-ship-details/edit-ship-details.component';
import { SubPoolComponent } from './stjs-fleet/stjs_components/sub-pool/sub-pool.component';
import { ConfirmModalComponent } from './stjs-fleet/stjs_components/confirm-modal/confirm-modal.component';
import { ScrubberComponent } from './scrubber/scrubber.component';
import { YearPickerComponent } from '../component-library/year-picker/year-picker.component';
import { CheckboxModule, ModalModule } from 'snl-complib';
import { DynamicTableComponent } from '../reusable_components/dynamic-table/dynamic-table.component';
import { StaticDataComponent } from '../reusable_components/static-data/static-data.component';
import { DistributionCalculationComponent } from './distribution-calculation/distribution-calculation.component';
import { ScrubberCalculationComponent } from './scrubber-calculation/scrubber-calculation.component';
import { authGuard } from '../auth/auth.guard';
import { LngComponent } from './lng/lng.component';
import { AddShipsComponent } from './fleet-management/add-ships/add-ships.component';
import { AddShipPointComponent } from './fleet-management/add-ship-point/add-ship-point.component';
import { AddShipReviewComponent } from './fleet-management/add-ship-review/add-ship-review.component';
import { FleetShipDetailComponent } from './fleet-management/fleet-ship-detail/fleet-ship-detail.component';
import { FleetManagementComponent } from './fleet-management/fleet-management.component';
import { DashboardChartComponent } from '../reusable_components/dashboard-chart/dashboard-chart.component';
import { MonitoringComponent } from './monitoring/monitoring.component';
import { PenaltyPointsSidebarComponent } from './fleet-management/penalty-points-sidebar/penalty-points-sidebar.component';
import { PenaltyHistoryComponent } from './fleet-management/penalty-history/penalty-history.component';
import { PointsManagementComponent } from './fleet-management/points-management/points-management.component';
import { EditPoolPointsComponent } from './fleet-management/edit-pool-points/edit-pool-points.component';
import { EditScrubberPointsComponent } from './fleet-management/edit-scrubber-points/edit-scrubber-points.component';
import { EditOverViewStatusComponent } from './fleet-management/edit-overview-status/edit-overview-status.component';
import { OverviewComponent } from './fleet-management/overview/overview.component';
import { EditLngComponent } from './fleet-management/edit-lng/edit-lng.component';
import { EditScrubberUsageComponent } from './fleet-management/edit-scrubber-usage/edit-scrubber-usage.component';


const pipe: any[] = [ShipOwnersPipe, NegativeToBracketPipe];

const routes: Routes = [
  { 
    path: '', 
    canActivate: [MsalGuard],
    component: AdminMainComponent, children: [
      { path: '', redirectTo: 'distribution', pathMatch: 'full' },
      { path: 'dashboard', component: DashboardComponent, pathMatch: 'full', data :{title:'Dashboard', allowedRoles: [1,2]}, canActivate: [authGuard]},
      { path: 'distribution', component: DistributionComponent, pathMatch: 'full', data :{title:'Distribution', allowedRoles: [1,2]}, canActivate: [authGuard]},
      { path: 'fleetlist', component: STJSFleetComponent, pathMatch: 'full', data :{title:'Fleet List', allowedRoles: [1]}, canActivate: [authGuard]},
      //fleetmanagement  - new route to manage fleet menu in version 2.0
      { path: 'fleetmanagement', component: FleetManagementComponent, pathMatch: 'full', data :{title:'Fleet List', allowedRoles: [1]}, canActivate: [authGuard]},
      { path: 'fleetmanagement/shipdetails', component: FleetShipDetailComponent, pathMatch: 'full', data :{title:'Fleet List', allowedRoles: [1]}, canActivate: [authGuard]},
      { path: 'monitoring', component: MonitoringComponent, pathMatch: 'full', data :{title:'Monitoring', allowedRoles: [1]}, canActivate: [authGuard]},
    ]
  }
];

@NgModule({
  declarations: [
    AdminMainComponent,
    SidebarComponent,
    YearPickerComponent,
    SearchInputComponent,
    DashboardComponent,
    DistributionComponent,
    STJSFleetComponent,
    ScrubberComponent,
    AddShipComponent,
    FleetManagementComponent,
    AddShipsComponent,
    AddShipPointComponent,
    AddShipReviewComponent,
    FleetShipDetailComponent,
    ...pipe,
    ShipDetailComponent,
    MarkAsStatusComponent,
    AddEditPenaltyComponent,
    EditShipDetailsComponent,
    SubPoolComponent,
    ConfirmModalComponent,
    DynamicTableComponent,
    StaticDataComponent,
    DistributionCalculationComponent,
    ScrubberCalculationComponent,
    LngComponent,
    DashboardChartComponent,
    MonitoringComponent,
    PenaltyPointsSidebarComponent,
    PenaltyHistoryComponent,
    PointsManagementComponent,
    OverviewComponent,
    EditPoolPointsComponent,
    EditScrubberPointsComponent,
    EditOverViewStatusComponent,
    EditLngComponent,
    EditScrubberUsageComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedSnlComplibModule,
    ReactiveFormsModule,
    HighchartsChartModule,
    NgSelectModule,
    DragDropModule,
    AutocompleteLibModule,
    ModalModule,
    CheckboxModule,
    RouterModule.forChild(routes)
  ],
  providers: [DatePipe, CurrencyPipe, DecimalPipe, NegativeToBracketPipe]
})
export class AdminModule { }
